import { render, staticRenderFns } from "./Frameworks.vue?vue&type=template&id=0fe6578c&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe6578c')) {
      api.createRecord('0fe6578c', component.options)
    } else {
      api.rerender('0fe6578c', component.options)
    }
    module.hot.accept("./Frameworks.vue?vue&type=template&id=0fe6578c&functional=true", function () {
      api.rerender('0fe6578c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/content/Frameworks.vue"
export default component.exports